import fetchLiveProfile from 'widget/LiveProfile/services/fetchLiveProfile';
import fetchTrackData from 'widget/LiveProfile/services/fetchTrackData';

export default { fetchLiveProfile, fetchTrackData };
